<template>
  <v-app-bar app color="primary" dark elevate-on-scroll height="60">
    <v-progress-linear
      indeterminate
      absolute
      top
      :active="$store.state.page_loader"
      color="white"
      background-color="primary"
    ></v-progress-linear>

    <v-row justify="center">
      <v-col md="8">
        <v-row align="center">
          <v-col cols="6" sm="auto">
            <router-link :to="{ name: 'home' }">
              <WedNicelyLogo class="logo" />
            </router-link>
          </v-col>
          <v-spacer></v-spacer>
          <v-menu>
            <template v-slot:activator="{ attrs, on }">
              <v-btn class="d-none d-sm-flex" text v-bind="attrs" v-on="on">
                <v-icon>$language</v-icon>
                {{ language }}
                <v-icon>{{ mdiChevronDown }}</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(lang, i) in language_list"
                :key="i"
                @click="changeLanguage(lang.name)"
              >
                <v-list-item-title>{{ lang.native_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-col cols="auto" class="d-none d-sm-flex">
            <v-btn
              color="white"
              class="primary--text"
              href="https://play.google.com/store/apps/details?id=com.codenicely.shaadicardmaker&hl=en_IN"
              rel="noopener"
              target="_blank"
            >
              <v-icon left>{{ mdiGooglePlay }}</v-icon> Try our app
            </v-btn>
          </v-col>
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-app-bar-nav-icon v-bind="attrs" v-on="on"></v-app-bar-nav-icon>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, i) in menu_contents"
                :key="i"
                :to="item.url"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!(user_email || user_mobile)"
                @click="showLoginDialog"
              >
                <v-list-item-title>Login</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import urls from "../app-js/urls.js";
import { mapGetters } from "vuex";
import { mdiChevronDown, mdiGooglePlay } from "@mdi/js";
import WedNicelyLogo from "@/assets/logo/wednicely_logo.svg?inline";

export default {
  components: {
    WedNicelyLogo
  },

  data() {
    return {
      mdiChevronDown,
      mdiGooglePlay,
      items: [
        { title: "Home", active: true, url: { name: "profile" } },
        { title: "Home", active: true, url: { name: "profile" } }
      ],
      language_list: [],
      language: null,
      menu_contents: [
        {
          title: "My Drafts",
          url: { name: "draftCards" }
        },
        {
          title: "My Purchases",
          url: { name: "purchasedCards" }
        },
        {
          title: "Favourites",
          url: { name: "favouritesCards" }
        },
        {
          title: "FAQ",
          url: { name: "faq" }
        },
        {
          title: "Contact Us",
          url: { name: "contactUs" }
        },
        {
          title: "About Us",
          url: { name: "aboutUs" }
        },
        {
          title: "Privacy Policy",
          url: { name: "privacyPolicy" }
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      user_email: "auth/getUserEmail",
      user_mobile: "auth/getUserMobile"
    })
  },

  async prefetch() {
    if (this.$store.state.language) this.language = this.$store.state.language;
    else this.language = "English";
    this.language_list = (await this.$axios.get(urls.LANGUAGES)).data.languages;
  },

  methods: {
    changeLanguage(language) {
      this.language = language;
      this.$store.state.language = language;
      localStorage.setItem("language", language);
      location.reload();
    },

    showLoginDialog() {
      this.$store.commit("SET_LOGIN_DIALOG", true, { root: true });
    }
  }
};
</script>

<style scoped>
.logo {
  width: 100%;
  max-width: 200px;
  color: #fff;
}
</style>
